import { Avatar, AvatarProps } from '@chakra-ui/react';
import { getUserFullName } from '@duke-hq/lib';

export function UserAvatar({
  user,
  ...props
}: {
  user: {
    first_name?: string | null | undefined;
    last_name?: string | null | undefined;
    picture_url?: string | null | undefined;
  };
} & AvatarProps) {
  return (
    <Avatar
      {...props}
      boxSize={props.size == null ? undefined : '10'}
      src={user.picture_url ?? undefined}
      name={getUserFullName(user)}
      sx={{
        '--avatar-font-size':
          typeof props.fontSize === 'string' || typeof props.fontSize === 'number'
            ? String(props.fontSize)
            : 'md',
        ...props.sx,
      }}
    />
  );
}
